export const CAROUSEL_FIELDS = [
    {
        key: 'carousel.dot.size',
        label: '페이지 점 크기',
        help: '홈 배너 아래쪽의 페이지 점(지금 몇 번째 배너인지 보여 주는 점) 지름입니다. 지금 보이는 배너의 점은 아래 "현재 점 너비"만큼 가로로 길어집니다.',
        group: '페이지 점',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: 8,
        min: 4,
        max: 16,
    },
    {
        key: 'carousel.dot.activeWidth',
        label: '현재 점 너비',
        help: '지금 보이는 배너를 가리키는 페이지 점의 가로 길이입니다. 점 크기와 같게 하면 모든 점이 동그랗습니다.',
        group: '페이지 점',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 4,
        max: 48,
    },
    {
        key: 'carousel.dot.inactiveOpacity',
        label: '다른 점 불투명도',
        help: '지금 보이지 않는 배너의 페이지 점 불투명도입니다(지금 보이는 배너의 점은 100%).',
        group: '페이지 점',
        type: 'integer',
        defaultValue: 50,
        min: 10,
        max: 100,
        unit: '%',
    },
    {
        key: 'carousel.dot.gap',
        label: '점 사이 간격',
        help: '페이지 점 사이의 간격입니다.',
        group: '페이지 점',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s',
        min: 0,
        max: 24,
    },
    {
        key: 'carousel.dot.bottomOffset',
        label: '점 아래 거리',
        help: '페이지 점 줄이 배너 아래 끝에서 떨어진 거리입니다.',
        group: '페이지 점',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.m-plus',
        min: 0,
        max: 48,
    },
    {
        key: 'carousel.dot.animationMs',
        label: '점 바뀌는 시간',
        help: '배너가 넘어갈 때 페이지 점이 길어지고 짧아지는 데 걸리는 시간입니다. 0이면 바로 바뀝니다.',
        group: '페이지 점',
        type: 'integer',
        defaultValue: 500,
        min: 0,
        max: 1500,
        unit: 'ms',
    },
    {
        key: 'carousel.banner.slideMs',
        label: '배너 넘어가는 시간',
        help: '홈 배너가 다음 배너로 미끄러져 넘어가는 동작에 걸리는 시간입니다. 다음 배너로 넘어가기까지 기다리는 시간은 화면 설정(홈 > 배너)의 자동 넘김 간격입니다.',
        group: '넘기기',
        type: 'integer',
        defaultValue: 1000,
        min: 200,
        max: 3000,
        unit: 'ms',
    },
    {
        key: 'carousel.image.slideMs',
        label: '상품 사진 넘어가는 시간',
        help: '상품 상세·상품 등록 화면 위쪽 사진 넘기기에서 다음 사진으로 미끄러져 넘어가는 동작에 걸리는 시간입니다.',
        group: '넘기기',
        type: 'integer',
        defaultValue: 500,
        min: 200,
        max: 3000,
        unit: 'ms',
    },
    {
        key: 'carousel.image.indexVisible',
        label: '상품 사진 순번 보이기',
        help: '상품 사진이 2장 이상일 때 사진 오른쪽 아래에 "1 • 5"처럼 몇 번째 사진인지 보여 줍니다.',
        group: '넘기기',
        type: 'boolean',
        defaultValue: true,
    },
];
//# sourceMappingURL=carousel.js.map